import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { ILogo } from 'planoplan-ui-kit/core/icons/i-logo';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { getGaId } from '@modules/helper';
import { Points } from '@styles';

export const Logo = ({ isDarkMode = false, isScrollUp = false, forceReload = false, reloadWhenNoGaId = false }) => {
  const { locale } = useSelector((state) => state.settings);
  const homeHref = `/${locale}/`;

  const handleClick = (event) => {
    const shouldReload = forceReload || (reloadWhenNoGaId && typeof window !== 'undefined' && getGaId() === 'nid');

    if (!shouldReload) return;

    event.preventDefault();
    window.location.href = homeHref;
  };

  const homeLabel = locale === 'ru' ? 'Планоплан — на главную' : 'Planoplan — home';

  return (
    <Link href="/" locale={locale} passHref>
      <Icon
        href={homeHref}
        aria-label={homeLabel}
        isMobile={deviceDetected.isMobile}
        isDarkMode={isDarkMode}
        isScrollUp={isScrollUp}
        data-logo="true"
        locale={locale}
        onClick={handleClick}>
        <ILogo rebrand="true" locale={locale} isNewVersion={true} />
      </Icon>
    </Link>
  );
};

const Icon = styled.a`
  ${Mixins.transition('opacity')};
  display: block;

  svg {
    display: block;
    width: ${(p) => (p.locale === 'ru' ? 140 : 127)}px;
    height: 35px;

    path:not(:first-of-type) {
      fill: ${(p) => (p.isScrollUp ? '#3f3f3f' : p.isDarkMode === true ? `${Colors.white}` : `${Colors.main_black}`)};
    }

    @media ${Points.tablet_landscape} {
      width: ${(p) => (p.locale === 'ru' ? 172 : 156)}px;
      height: 44px;
    }
  }

  &:hover {
    opacity: ${(p) => !p.isMobile && 0.8};
  }
`;
